import React, { useLayoutEffect } from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { TopNav } from "@/components/TopNav";
import { useTheme } from "@/hooks/use-theme";
import { cn } from "@/lib/utils";
import { Toaster } from "@/components/ui/sonner";
type AppLayoutProps = {
  children: React.ReactNode;
  container?: boolean;
  className?: string;
  contentClassName?: string;
};
export function AppLayout({ children, container = false, className, contentClassName }: AppLayoutProps): JSX.Element {
  const { theme } = useTheme();
  useLayoutEffect(() => {
    const root = window.document.documentElement;
    let resolvedTheme = theme;
    if (theme === 'system') {
      resolvedTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    root.classList.remove('light', 'dark');
    root.classList.add(resolvedTheme);
  }, [theme]);
  return (
    <SidebarProvider defaultOpen={true}>
      <Toaster theme={theme} />
      <div className="flex flex-col h-screen overflow-hidden bg-background w-full relative transition-colors duration-300">
        <TopNav />
        <div className="flex flex-1 overflow-hidden w-full relative">
          <AppSidebar />
          <SidebarInset className={cn(
            "flex-1 overflow-y-auto bg-transparent relative w-full h-full",
            className
          )}>
            <main className="flex-1 w-full min-h-full">
              {container ? (
                <div className={cn(
                  "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-10 lg:py-12",
                  contentClassName
                )}>
                  {children}
                </div>
              ) : (
                children
              )}
            </main>
          </SidebarInset>
        </div>
      </div>
    </SidebarProvider>
  );
}